module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedThin.5d41943.eot";